import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Input,
  Space,
  Spin,
  Table,
  Image,
  Rate,
  Popconfirm,
  message,
  Select,
} from "antd";
import { shopRateApi } from "api/shopRate.api";
import { Pagination } from "components/Pagination";
import React, { useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import { QueryParam } from "types/query";
import { ShopRate } from "types/shop-rate";
import { getTitle } from "utils";
import { $url } from "utils/url";

const { Option } = Select;
const { ColumnGroup, Column } = Table;

interface ShopRateQuery extends QueryParam {
  star: number | null;
  isHasImage?: boolean;
}

export const ShopRateTab = ({ shopId = 0 }) => {
  const [query, setQuery] = useState<ShopRateQuery>({
    page: 1,
    limit: 50,
    search: "",
    star: null,
  });

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ShopRate[]>([]);
  const [total, setTotal] = useState(0);
  const [visibleModal, setVisibleModal] = useState(false);
  const [selectedShopRate, setSelectedShopRate] = useState<Partial<ShopRate>>(
    {}
  );
  const [modalStatus, setModalStatus] = useState<ModalStatus>("create");

  useEffect(() => {
    if (shopId) {
      fetchData();
    }
  }, [query, shopId]);

  useEffect(() => {
    query.page = 1;
    setQuery({ ...query });
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const res = await shopRateApi.findAll({
      ...query,
      shopId,
    });
    setLoading(false);
    setData(res.data.rates);
    setTotal(res.data.total);
  };

  const handleDelete = async (rate: ShopRate) => {
    setLoading(true);
    try {
      await shopRateApi.delete(rate.id);
      fetchData();
      message.success("Xóa thành công");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="filter-container">
        <Space>
          <div className="filter-item">
            <label htmlFor="">Số sao</label>
            <br />
            <Select
              allowClear
              style={{ width: 150 }}
              onChange={(star) => {
                query.star = star;
                setQuery({ ...query });
              }}
            >
              <Option value={1}>1 sao</Option>
              <Option value={2}>2 sao</Option>
              <Option value={3}>3 sao</Option>
              <Option value={4}>4 sao</Option>
              <Option value={5}>5 sao</Option>
            </Select>
          </div>

          <div className="filter-item">
            <label htmlFor="">Hình ảnh</label>
            <br />
            <Select
              allowClear
              style={{ width: 150 }}
              onChange={(val) => {
                query.isHasImage = val;
                setQuery({ ...query });
              }}
            >
              <Option value={true}>Có</Option>
              <Option value={false}>Không</Option>
            </Select>
          </div>

          <div className="filter-item btn">
            <Button
              onClick={fetchData}
              type="primary"
              icon={<SearchOutlined />}
            >
              Tìm kiếm
            </Button>
          </div>
        </Space>
      </div>

      <Spin spinning={loading}>
        <Table pagination={false} rowKey="id" dataSource={data}>
          <Column
            title="Khách hàng"
            dataIndex="username"
            key="username"
            render={(text, record: ShopRate) => {
              return (
                <div>
                  <div>
                    <Button
                      style={{ padding: 0 }}
                      type="link"
                      href={`tel:${record.customer?.phone}`}
                    >
                      {record.customer?.phone}
                    </Button>
                  </div>

                  <div>
                    <span>
                      {record.customer?.firstName} {record.customer?.lastName}
                    </span>
                  </div>

                  <div>
                    <span>{record.customer?.address}</span>
                  </div>
                </div>
              );
            }}
          />
          <Column
            title="Bình luận"
            render={(text, record: ShopRate) => (
              <div>
                {record.image && <Image src={$url(record.image)} width={80} />}
                <br />
                <Rate defaultValue={record.star} disabled />
                <br />
                <span>{record.content}</span>
              </div>
            )}
          />

          <Column
            title="Thao tác"
            key="action"
            render={(text, record: ShopRate) => (
              <span>
                <Popconfirm
                  placement="top"
                  title="Xác nhận xóa bình luận này?"
                  cancelText="Không"
                  okText="Xóa"
                  onConfirm={() => {
                    handleDelete(record);
                  }}
                >
                  <Button danger>Xóa</Button>
                </Popconfirm>
              </span>
            )}
          />
        </Table>

        <Pagination
          currentPage={query.page}
          total={total}
          onChange={({ limit, page }) => {
            query.page = page;
            query.limit = limit;
            setQuery({ ...query });
          }}
        />
      </Spin>
    </div>
  );
};
